// widget-icon-registry.js
import {
  getBrightnessIcon,
  getBrightnessPatterns,
  getBrightnessSubtitle,
} from "./twin-widget/onoff-brightness-color-helper";
import {
  getColorIcon,
  getColorPatterns,
  getColorSubtitle,
} from "./twin-widget/color-helper";
import {
  getMotionIcon,
  getMotionPatterns,
  getMotionSubtitle,
} from "./twin-widget/motion-helper";
import {
  getPresentIcon,
  getPresentPatterns,
  getPresentSubtitle,
} from "./twin-widget/present-helper";
import {
  getContactSensorIcon,
  getContactSensorPatterns,
  getContactSensorSubtitle,
} from "./twin-widget/contact-sensor-helper";
import {
  getTemperatureIcon,
  getTemperaturePatterns,
  getTemperatureSubtitle,
} from "./twin-widget/temperature-helper";
import {
  getHumidityIcon,
  getHumidityPatterns,
  getHumiditySubtitle,
} from "./twin-widget/humidity-helper";
import {
  getIlluminanceIcon,
  getIlluminancePatterns,
  getIlluminanceSubtitle,
} from "./twin-widget/illuminance-helper";
import {
  getLockIcon,
  getLockPatterns,
  getLockSubtitle,
} from "./twin-widget/lock-helper";
import {
  getWindowIcon,
  getWindowPatterns,
  getWindowSubtitle,
} from "./twin-widget/window-helper";
import {
  getVolumeMuteIcon,
  getVolumeMutePatterns,
} from "./twin-widget/volume-mute-helper";
import {
  getMediaPlaybackIcon,
  getMediaPlaybackPatterns,
  getMediaPlaybackSubtitle,
} from "./twin-widget/media-playback-helper";
import {
  getFanIcon,
  getFanPatterns,
  getFanSubtitle,
} from "./twin-widget/fan-helper";
import {
  getThermostatIcon,
  getThermostatPatterns,
  getThermostatSubtitle,
} from "./twin-widget/thermostat-helper";
import {
  getButtonPressIcon,
  getButtonPressPatterns,
  getButtonPressSubtitle,
} from "./twin-widget/buttonpress-helper";
import {
  getOnlineIcon,
  getOnlinePatterns,
  getOnlineSubtitle,
} from "./twin-widget/online-helper";
import {
  getCircadianIcon,
  getCircadianPatterns,
  getCircadianSubtitle,
} from "./twin-widget/circadian-helper";
import {
  getButtonIcon,
  getButtonPatterns,
  getGenericWidgetIcon,
} from "./widget/general-widget-helper";
import { getDefaultIcon } from "./widget/default-helper";

const iconMap = new Map();
const subtitleMap = new Map();

/**
 * Register all widget icon helpers
 */
export const registerWidgetIcons = () => {
  // Register twin widget icons and subtitles
  getBrightnessPatterns().forEach((pattern) => {
    iconMap.set(pattern, getBrightnessIcon);
    subtitleMap.set(pattern, getBrightnessSubtitle);
  });

  getColorPatterns().forEach((pattern) => {
    iconMap.set(pattern, getColorIcon);
    subtitleMap.set(pattern, getColorSubtitle);
  });

  getMotionPatterns().forEach((pattern) => {
    iconMap.set(pattern, getMotionIcon);
    subtitleMap.set(pattern, getMotionSubtitle);
  });

  getPresentPatterns().forEach((pattern) => {
    iconMap.set(pattern, getPresentIcon);
    subtitleMap.set(pattern, getPresentSubtitle);
  });

  getContactSensorPatterns().forEach((pattern) => {
    iconMap.set(pattern, getContactSensorIcon);
    subtitleMap.set(pattern, getContactSensorSubtitle);
  });

  getTemperaturePatterns().forEach((pattern) => {
    iconMap.set(pattern, getTemperatureIcon);
    subtitleMap.set(pattern, getTemperatureSubtitle);
  });

  getHumidityPatterns().forEach((pattern) => {
    iconMap.set(pattern, getHumidityIcon);
    subtitleMap.set(pattern, getHumiditySubtitle);
  });

  getIlluminancePatterns().forEach((pattern) => {
    iconMap.set(pattern, getIlluminanceIcon);
    subtitleMap.set(pattern, getIlluminanceSubtitle);
  });

  getLockPatterns().forEach((pattern) => {
    iconMap.set(pattern, getLockIcon);
    subtitleMap.set(pattern, getLockSubtitle);
  });

  getWindowPatterns().forEach((pattern) => {
    iconMap.set(pattern, getWindowIcon);
    subtitleMap.set(pattern, getWindowSubtitle);
  });

  getVolumeMutePatterns().forEach((pattern) => {
    iconMap.set(pattern, getVolumeMuteIcon);
  });

  getMediaPlaybackPatterns().forEach((pattern) => {
    iconMap.set(pattern, getMediaPlaybackIcon);
    subtitleMap.set(pattern, getMediaPlaybackSubtitle);
  });

  getFanPatterns().forEach((pattern) => {
    iconMap.set(pattern, getFanIcon);
    subtitleMap.set(pattern, getFanSubtitle);
  });

  getThermostatPatterns().forEach((pattern) => {
    iconMap.set(pattern, getThermostatIcon);
    subtitleMap.set(pattern, getThermostatSubtitle);
  });

  getButtonPressPatterns().forEach((pattern) => {
    iconMap.set(pattern, getButtonPressIcon);
    subtitleMap.set(pattern, getButtonPressSubtitle);
  });

  getOnlinePatterns().forEach((pattern) => {
    iconMap.set(pattern, getOnlineIcon);
    subtitleMap.set(pattern, getOnlineSubtitle);
  });

  getCircadianPatterns().forEach((pattern) => {
    iconMap.set(pattern, getCircadianIcon);
    subtitleMap.set(pattern, getCircadianSubtitle);
  });

  getButtonPatterns().forEach((pattern) => {
    iconMap.set(pattern, getButtonIcon);
  });
};

export const registerWidgetIcon = (pattern, iconGetter) => {
  iconMap.set(pattern, iconGetter);
};

export const getWidgetIcon = (pattern, widget = null) => {
  if (!pattern) return null;

  // Try to get exact match from registry
  const iconGetter = iconMap.get(pattern);
  if (iconGetter) {
    return iconGetter(widget);
  }

  // If pattern doesn't contain "." it's a widget pattern (not device pattern)
  if (!pattern.includes(".")) {
    return getGenericWidgetIcon(widget);
  }

  return getDefaultIcon(widget);
};

export const getWidgetSubtitle = (pattern, widget = null) => {
  if (!pattern || !widget) return "";

  // Try to get exact match from registry
  const subtitleGetter = subtitleMap.get(pattern);
  if (subtitleGetter) {
    return subtitleGetter(widget);
  }

  return "";
};

/**
 * Get a default device icon (fallback)
 */
export const getDefaultDeviceIcon = () => {
  return getDefaultIcon();
};
